export default "__VITE_ASSET__Wdoa01V6__"